import { defineLocale } from "../../registry";

const geometry = defineLocale({
  ru: {
    "editor.tab.geometry": "Геометрия",

    "geometry.map.label": "Карта",
    "geometry.map.noKey":
      "Карта недоступна: не задан ключ Google Maps. Введите координаты вручную в таблице ниже.",
    "geometry.map.loading": "Загрузка карты…",
    "geometry.map.loadFailed":
      "Не удалось загрузить карту. Координаты можно вводить вручную.",
    "geometry.map.authFailed":
      "Google Maps отклонил ключ. Координаты можно вводить вручную.",
    "geometry.map.retry": "Повторить загрузку карты",
    "geometry.map.hint":
      "Клик по карте добавляет точку, маркер можно перетащить.",
    "geometry.map.roadNote":
      "Дорожный маршрут показан прямой линией для ориентира; реальный путь строит приложение.",

    "geometry.kind.legend": "Вид геометрии",
    "geometry.kind.none": "Нет геометрии",
    "geometry.kind.point": "Одна точка",
    "geometry.kind.points": "Несколько точек",
    "geometry.kind.route": "Маршрут",
    "geometry.kind.noneHint":
      "У этого Pick нет геометрии. Выберите вид, чтобы добавить точки.",

    "geometry.route.mode": "Тип маршрута",
    "geometry.route.mode.drawn": "Линия по точкам",
    "geometry.route.mode.road": "Дорожный маршрут (строит приложение)",
    "geometry.route.travelMode": "Способ передвижения",
    "geometry.route.travel.walking": "Пешком",
    "geometry.route.travel.driving": "На машине",

    "geometry.points.title": "Точки",
    "geometry.points.count": "{count} из {max}",
    "geometry.points.empty":
      "Точек пока нет. Кликните по карте или добавьте точку вручную.",
    "geometry.points.add": "Добавить точку",
    "geometry.points.col.index": "№",
    "geometry.points.col.lat": "Широта",
    "geometry.points.col.lon": "Долгота",
    "geometry.points.col.label": "Подпись",
    "geometry.points.col.role": "Роль",
    "geometry.points.col.actions": "Действия",
    "geometry.points.lat": "Широта точки {n}",
    "geometry.points.lon": "Долгота точки {n}",
    "geometry.points.label": "Подпись точки {n}",
    "geometry.points.role": "Роль точки {n}",
    "geometry.points.moveUp": "Поднять точку {n}",
    "geometry.points.moveDown": "Опустить точку {n}",
    "geometry.points.remove": "Удалить точку {n}",
    "geometry.role.start": "Старт",
    "geometry.role.stop": "Остановка",
    "geometry.role.end": "Финиш",
    "geometry.role.anchor": "Якорь",

    "geometry.rights.title": "Права на геометрию",
    "geometry.rights.source": "Источник",
    "geometry.rights.license": "Лицензия",
    "geometry.rights.licenseNone": "Не выбрана",
    "geometry.rights.attribution": "Атрибуция",
    "geometry.rights.status": "Статус прав",
    "geometry.rights.hint":
      "В черновике права можно оставить неполными; для публикации сервер их потребует.",
    "geometry.rights.resetNote":
      "Изменение точек или линии сбрасывает статус прав в «Неизвестно»: подтвердите его после сохранения.",
    "geometry.license.own": "Собственная",
    "geometry.license.cc_by": "CC BY",
    "geometry.license.cc_by_sa": "CC BY-SA",
    "geometry.license.odbl": "ODbL",
    "geometry.rightsStatus.licensed": "Лицензировано",
    "geometry.rightsStatus.permission": "Есть разрешение",
    "geometry.rightsStatus.editorial_free": "Редакционное использование",
    "geometry.rightsStatus.unknown": "Неизвестно",

    "geometry.issues.title": "Что нужно исправить перед сохранением",
    "geometry.issue.point_required": "Для одной точки нужна ровно одна точка.",
    "geometry.issue.min_two": "Нужно минимум две точки.",
    "geometry.issue.coordinate_invalid": "Введите число.",
    "geometry.issue.bounds":
      "Широта от −90 до 90, долгота от −180 до 180.",
    "geometry.issue.points_limit": "Не больше {max} точек.",
    "geometry.issue.road_points_limit":
      "Для дорожного маршрута не больше {max} точек.",
    "geometry.issue.path_limit": "В линии не больше {max} вершин.",
    "geometry.issue.label_too_long": "Подпись не длиннее {max} символов.",
    "geometry.issue.attribution_too_long":
      "Атрибуция не длиннее {max} символов.",
    "geometry.issue.body_too_large": "Геометрия больше {max} КБ.",

    "geometry.reason.bounds":
      "Сервер: координаты вне допустимых границ.",
    "geometry.reason.combination":
      "Сервер: вид геометрии не сочетается с набором точек или маршрутом.",
    "geometry.reason.points_limit": "Сервер: слишком много точек.",
    "geometry.reason.path_limit": "Сервер: в линии слишком много вершин.",
    "geometry.reason.label_too_long": "Сервер: слишком длинная подпись.",
    "geometry.reason.source_missing": "Сервер: укажите источник.",
    "geometry.reason.license_not_allowed":
      "Сервер: эта лицензия не допускается.",
    "geometry.reason.attribution_missing": "Сервер: укажите атрибуцию.",
    "geometry.reason.unknown": "Сервер не принял геометрию.",

    "geometry.warning.points_outside_places_bbox":
      "Точка лежит за пределами области мест этого Pick.",
    "geometry.warning.unknown": "Предупреждение сервера по этой точке.",
  },
  en: {
    "editor.tab.geometry": "Geometry",

    "geometry.map.label": "Map",
    "geometry.map.noKey":
      "The map is unavailable: no Google Maps key is configured. Enter coordinates by hand in the table below.",
    "geometry.map.loading": "Loading the map…",
    "geometry.map.loadFailed":
      "The map could not be loaded. You can still enter coordinates by hand.",
    "geometry.map.authFailed":
      "Google Maps rejected the key. You can still enter coordinates by hand.",
    "geometry.map.retry": "Retry loading the map",
    "geometry.map.hint": "Click the map to add a point; drag a marker to move it.",
    "geometry.map.roadNote":
      "A road route is previewed as a straight line; the app builds the real path.",

    "geometry.kind.legend": "Geometry type",
    "geometry.kind.none": "No geometry",
    "geometry.kind.point": "Single point",
    "geometry.kind.points": "Several points",
    "geometry.kind.route": "Route",
    "geometry.kind.noneHint":
      "This Pick has no geometry. Choose a type to add points.",

    "geometry.route.mode": "Route type",
    "geometry.route.mode.drawn": "Line through the points",
    "geometry.route.mode.road": "Road route (built by the app)",
    "geometry.route.travelMode": "Travel mode",
    "geometry.route.travel.walking": "Walking",
    "geometry.route.travel.driving": "Driving",

    "geometry.points.title": "Points",
    "geometry.points.count": "{count} of {max}",
    "geometry.points.empty":
      "No points yet. Click the map or add a point by hand.",
    "geometry.points.add": "Add point",
    "geometry.points.col.index": "#",
    "geometry.points.col.lat": "Latitude",
    "geometry.points.col.lon": "Longitude",
    "geometry.points.col.label": "Label",
    "geometry.points.col.role": "Role",
    "geometry.points.col.actions": "Actions",
    "geometry.points.lat": "Latitude of point {n}",
    "geometry.points.lon": "Longitude of point {n}",
    "geometry.points.label": "Label of point {n}",
    "geometry.points.role": "Role of point {n}",
    "geometry.points.moveUp": "Move point {n} up",
    "geometry.points.moveDown": "Move point {n} down",
    "geometry.points.remove": "Remove point {n}",
    "geometry.role.start": "Start",
    "geometry.role.stop": "Stop",
    "geometry.role.end": "End",
    "geometry.role.anchor": "Anchor",

    "geometry.rights.title": "Geometry rights",
    "geometry.rights.source": "Source",
    "geometry.rights.license": "License",
    "geometry.rights.licenseNone": "Not chosen",
    "geometry.rights.attribution": "Attribution",
    "geometry.rights.status": "Rights status",
    "geometry.rights.hint":
      "Rights may stay incomplete in a draft; the server requires them to publish.",
    "geometry.rights.resetNote":
      "Changing points or the line resets the rights status to “Unknown”: confirm it again after saving.",
    "geometry.license.own": "Own",
    "geometry.license.cc_by": "CC BY",
    "geometry.license.cc_by_sa": "CC BY-SA",
    "geometry.license.odbl": "ODbL",
    "geometry.rightsStatus.licensed": "Licensed",
    "geometry.rightsStatus.permission": "Permission granted",
    "geometry.rightsStatus.editorial_free": "Editorial use",
    "geometry.rightsStatus.unknown": "Unknown",

    "geometry.issues.title": "Fix before saving",
    "geometry.issue.point_required": "A single point needs exactly one point.",
    "geometry.issue.min_two": "At least two points are required.",
    "geometry.issue.coordinate_invalid": "Enter a number.",
    "geometry.issue.bounds":
      "Latitude must be within −90 to 90, longitude within −180 to 180.",
    "geometry.issue.points_limit": "At most {max} points.",
    "geometry.issue.road_points_limit": "A road route allows at most {max} points.",
    "geometry.issue.path_limit": "The line may have at most {max} vertices.",
    "geometry.issue.label_too_long": "A label is at most {max} characters.",
    "geometry.issue.attribution_too_long":
      "Attribution is at most {max} characters.",
    "geometry.issue.body_too_large": "The geometry is larger than {max} KB.",

    "geometry.reason.bounds": "Server: coordinates are out of bounds.",
    "geometry.reason.combination":
      "Server: this geometry type does not fit the points or route.",
    "geometry.reason.points_limit": "Server: too many points.",
    "geometry.reason.path_limit": "Server: the line has too many vertices.",
    "geometry.reason.label_too_long": "Server: a label is too long.",
    "geometry.reason.source_missing": "Server: enter a source.",
    "geometry.reason.license_not_allowed": "Server: this license is not allowed.",
    "geometry.reason.attribution_missing": "Server: enter an attribution.",
    "geometry.reason.unknown": "The server did not accept the geometry.",

    "geometry.warning.points_outside_places_bbox":
      "This point lies outside the area of the Pick's places.",
    "geometry.warning.unknown": "Server warning for this point.",
  },
});

export default geometry;
